import { trace, type Tracer } from '@opentelemetry/api';

export const SERVICE_NAME = 'sysarb-vue-client';

export const getTracer = (name: string = SERVICE_NAME): Tracer => trace.getTracer(name);
